import { useEffect, useState } from 'react';
import { getAccessToken } from '../helpers';
import { formsLibrary } from '../../../forms-library.config';

export function useFetchProfileData(
  setProfileLoading: any,
  accessToken: string,
) {
  const [apiData, setApiData] = useState(null);
  const [errMsg, setErrMsg] = useState(null);

  const config = formsLibrary.getConfig();
  const { HIGHMARK_API_URL, useCurrentRegionUbkHeader } = config;
  const currentUbk: any = useCurrentRegionUbkHeader() || null;
  const ubkValue = currentUbk?.headers?.Brandubk || null;
  const url = `${HIGHMARK_API_URL}/digital/v1/members/demographics/profile`;
  useEffect(() => {
    setProfileLoading(true);
    getAccessToken(url, ubkValue, '', accessToken).then((result: any) => {
      const userData = result?.demographics;
      const errData = result?.errMsg;
      setProfileLoading(false);
      if (userData) {
        setApiData(result);
      } else if (errData) {
        setErrMsg(errData);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  return [apiData, errMsg];
}
